export default "__VITE_ASSET__DJQlAlqI__"